import React from "react";
import { Calendar, X } from "lucide-react";
import { monthNames } from "./constants";
import { Holiday, HolidayApiResponse, HolidayMap } from "../../types";

interface HolidayApiItem {
  id: number;
  name: string;
  date: string; // format: "25 Apr 2025"
  leave_type_display: "Federal" | "Company" | "Observed";
}

interface MonthlyHolidaysListProps {
  currentDate: Date;
  holidays: HolidayApiResponse;
  onHolidaySelect: (holiday: Holiday) => void; // ✅ was (date: Date)
  onRemoveHoliday: (date: Date) => void;
}


const MonthlyHolidaysList: React.FC<MonthlyHolidaysListProps> = ({
  currentDate,
  holidays,
  onHolidaySelect,
  onRemoveHoliday,
}) => {
  const month = currentDate.getMonth();
  const year = currentDate.getFullYear();

  const filteredHolidays =
    holidays?.result?.filter((holiday) => {
      const parsedDate = new Date(holiday.date);
      return (
        parsedDate.getMonth() === month && parsedDate.getFullYear() === year
      );
    }) ?? [];
  const getTypeClass = (type: string) => {
    switch (type.toLowerCase()) {
      case "federal":
        return "bg-red-100 text-red-700";
      case "company":
        return "bg-green-100 text-green-700";
      case "observed":
        return "bg-orange-100 text-orange-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  const getDateObject = (dateStr: string) => {
    return new Date(dateStr);
  };

  return (


    <div className="bg-white rounded-lg border border-gray-200 p-6 h-full">
      <div className="flex items-center gap-2 mb-4">
        <Calendar className="w-5 h-5 text-gray-600" />
        <h3 className="card-heading-text">
          {monthNames[month]} {year} Holidays
        </h3>
      </div>

      {filteredHolidays.length === 0 ? (
        <p className="text-gray-500 text-center py-8">No holidays this month</p>
      ) : (
        // 👇 Apply fixed height and scroll
        <div className="space-y-3 max-h-[24rem] overflow-y-auto pr-1">
          {filteredHolidays.map((holiday) => {
            const dateObj = getDateObject(holiday.date);
            const displayType = holiday.leaveTypeDisplay.toLowerCase();
            return (
              <div
                key={holiday.id}
                className="flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors group"
                onClick={() => onHolidaySelect(holiday)}
              >
                <div className="flex-1">
                  <div className="font-medium text-gray-900">
                    {dateObj.getDate()} {monthNames[dateObj.getMonth()]}
                  </div>
                  <div className="text-sm text-gray-600">{holiday.name}</div>
                </div>

                <div className="flex items-center gap-2">
                  <span
                    className={`px-2 py-1 text-xs rounded-full ${getTypeClass(
                      displayType
                    )}`}
                  >
                    {holiday.leaveTypeDisplay}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MonthlyHolidaysList;
